import { Component, Input } from '@angular/core';
import { UserLabel } from '@app/pcs/models';
import { getLabelColor, getLabelName } from '@app/pcs/util/user-label';
import { GridCell } from 'ngrx-data-grid';

@Component({
  templateUrl: './labels-column.component.html'
})
export class LabelsColumnComponent implements GridCell<UserLabel[]> {
  @Input() data: UserLabel[];

  trackByIndex(_, index) {
    return index;
  }

  getName(label: UserLabel) {
    return getLabelName(label);
  }

  getColor(label: UserLabel) {
    return getLabelColor(label);
  }
}
